import Vue from "vue";

//helper app
import "./Components/Helpers/HelperComponent";

/**
 * all component of GUD
 */
Vue.component(
  "personal-information",
  require("./Components/Views/Auth/PersonalInformation").default
);
Vue.component(
  "password-change",
  require("./Components/Views/Auth/PasswordChange").default
);
Vue.component(
  "social-links",
  require("./Components/Views/Auth/SocialLinks").default
);
Vue.component("login", require("./Components/Views/Auth/Login").default);
Vue.component(
  "password-reset",
  require("./Components/Views/Auth/PasswordReset").default
);
Vue.component(
  "reset-password",
  require("./Components/Views/Auth/ResetPassword").default
);
Vue.component(
  "registration",
  require("./Components/Views/Auth/Registration").default
);
Vue.component('user-verified', require('./Components/Views/Auth/UserVerified').default);
Vue.component("my-profile", require("./Components/Views/Auth/Profile").default);

// Settings
Vue.component(
  "app-setting",
  require("./Components/Views/Settings/Index").default
);
Vue.component(
  "general-setting",
  require("./Components/Views/Settings/GeneralSetting").default
);
Vue.component(
  "email-setting",
  require("./Components/Views/Settings/EmailSetting").default
);
Vue.component(
  "sms-setting",
  require("./Components/Views/Settings/SmsSetting").default
);
Vue.component(
  "google-re-captcha-setting",
  require("./Components/Views/Settings/GoogleRecaptchaSetting").default
);
Vue.component(
  "notification-settings",
  require("./Components/Views/Settings/Notification/Settings/Index").default
);
Vue.component(
  "storage-setting",
  require("./Components/Views/Settings/Storage/Index").default
);
Vue.component(
  "database-template",
  require("./Components/Views/Settings/Notification/Template/DatabaseTemplate")
    .default
);
Vue.component(
  "mail-template",
  require("./Components/Views/Settings/Notification/Template/MailTemplate")
    .default
);
Vue.component(
  "payment-method",
  require("./Components/Views/Settings/PaymentMethod/PaymentMethod").default
);
Vue.component(
  "payment-method-create-edit-modal",
  require("./Components/Views/Settings/PaymentMethod/PaymentMethodCreateEditModal")
    .default
);

// User and Roles
Vue.component(
  "user-roles",
  require("./Components/Views/UserRoles/Index").default
);
Vue.component(
  "group-of-users",
  require("./Components/Views/UserRoles/Roles/GroupOfUsers").default
);

// Layouts
Vue.component(
  "app-top-bar",
  require("./Components/Views/Layouts/Nabar").default
);
Vue.component(
  "app-sidebar",
  require("./Components/Views/Layouts/Sidebar").default
);

// notifications
Vue.component(
  "all-notification",
  require("./Components/Views/Auth/Notification").default
);

Vue.component(
  "re-captcha",
  require("./Components/Views/Auth/ReCaptcha").default
);
Vue.component(
  "payment-view",
  require("./Components/Views/Demo/Pages/PaymentMethodView").default
);

//Custom Table
Vue.component(
  "app-custom-tables",
  require("./Components/Views/Settings/CustomTable/CustomTable").default
);
Vue.component(
  "app-custom-table-modal",
  require("./Components/Views/Settings/CustomTable/CustomTableModal").default
);

// Dynamic table
Vue.component(
  "app-custom-table-dynamic",
  require("./Components/Views/Demo/CustomTable/DynamicPage").default
);

// Master
Vue.component(
  "inquiry-type",
  require("./Components/Views/Master/InquiryType/Index").default
);
Vue.component(
  "lead-status",
  require("./Components/Views/Master/LeadStatus/Index").default
);
Vue.component(
  "marketing-channel",
  require("./Components/Views/Master/MarketingChannel/Index").default
);
Vue.component(
  "school",
  require("./Components/Views/Master/School/Index").default
);
Vue.component(
  "school-level",
  require("./Components/Views/Master/SchoolLevel/Index").default
);
Vue.component(
  "naming-series",
  require("./Components/Views/Master/NamingSeries/Index").default
);
Vue.component(
  "partner",
  require("./Components/Views/Master/Partner/Index").default
);
Vue.component(
  "country",
  require("./Components/Views/Master/Country/Index").default
);
Vue.component(
  "province",
  require("./Components/Views/Master/Province/Index").default
);
Vue.component("city", require("./Components/Views/Master/City/Index").default);
Vue.component(
  "district",
  require("./Components/Views/Master/District/Index").default
);
Vue.component(
  "village",
  require("./Components/Views/Master/Village/Index").default
);
Vue.component(
  "voucher-request",
  require("./Components/Views/Master/VoucherRequest/Index").default
);
Vue.component(
  "voucher",
  require("./Components/Views/Master/Voucher/Index").default
);
Vue.component(
  "voucher-category",
  require("./Components/Views/Master/VoucherCategory/Index").default
);
Vue.component(
  "master-event-registration",
  require("./Components/Views/Master/EventRegistration/Index").default
);
Vue.component(
  "master-inquiry",
  require("./Components/Views/Master/Inquiry/Index").default
);
Vue.component(
  "centre",
  require("./Components/Views/Master/Center/Index").default
);
Vue.component(
  "clc-calendar",
  require("./Components/Views/Master/ClcCalendar/Index").default
);
Vue.component(
  "clc-calendar-table-header",
  require("./Components/Views/Master/ClcCalendar/Table").default
)
Vue.component(
  "clc-calendar-table-detail",
  require("./Components/Views/Master/ClcCalendar/TableDetail").default
)
Vue.component(
  "learning-interest",
  require("./Components/Views/Master/LearningInterest/Index").default
);
Vue.component(
  "price-list",
  require("./Components/Views/Master/PriceList/Index").default
);

Vue.component(
  "minimum-apps-value",
  require("./Components/Views/Master/MinimumAppsValue/Index").default
);

// Master - Table
Vue.component(
  "master-event-registration-detail-table",
  require("./Components/Views/Master/EventRegistration/EventRegistrationDetailTable")
    .default
);

Vue.component(
  "test-content",
  require("./Components/Views/Master/TestContent/Index").default
);
Vue.component(
  "reason",
  require("./Components/Views/Master/Reason/Index").default
);
Vue.component(
  "teaching-type",
  require("./Components/Views/Master/TeachingType/Index").default
);
Vue.component(
  "product-category",
  require("./Components/Views/Master/ProductCategory/Index").default
);
Vue.component(
  "product-type",
  require("./Components/Views/Master/ProductType/Index").default
);
Vue.component(
  "course-type",
  require("./Components/Views/Master/CourseType/Index").default
);
Vue.component(
  "product-level",
  require("./Components/Views/Master/ProductLevel/Index").default
);
Vue.component(
  "language-list",
  require("./Components/Views/Master/Language/Index").default
);
Vue.component(
  "template-comment",
  require("./Components/Views/Master/TemplateComment/Index").default
);
Vue.component(
  "product-status",
  require("./Components/Views/Master/ProductStatus/Index").default
);
Vue.component(
  "payment-status",
  require("./Components/Views/Master/PaymentStatus/Index").default
);
Vue.component("uom", require("./Components/Views/Master/UOM/Index").default);
Vue.component(
  "appointment-type",
  require("./Components/Views/Master/AppointmentType/Index").default
);
Vue.component(
  "product",
  require("./Components/Views/Master/Product/Index").default
);
Vue.component(
  "info-product",
  require("./Components/Views/Master/Product/InfoProduct").default
);
Vue.component(
  "charges",
  require("./Components/Views/Master/Charges/Index").default
);
Vue.component(
  "deductions",
  require("./Components/Views/Master/Deductions/Index").default
);

Vue.component(
  "bank",
  require("./Components/Views/Master/Bank/Index").default
);
Vue.component(
  "bank-account",
  require("./Components/Views/Master/BankAccount/Index").default
);

Vue.component(
  "sales-payment",
  require("./Components/Views/Transaction/SalesPayment/Index").default
);
Vue.component(
  "migration-status",
  require("./Components/Views/Transaction/MigrationStatus/Index").default
)
Vue.component(
  "finance-book",
  require("./Components/Views/Master/FinanceBook/Index").default
)
Vue.component(
  "invoice-request-list",
  require("./Components/Views/Transaction/InvoiceRequest/Index").default
)
Vue.component(
  "invoice-request-table",
  require("./Components/Views/Transaction/InvoiceRequest/ListTable.vue").default
)
Vue.component(
  "product-approval",
  require("./Components/Views/Transaction/ProductApproval/Index").default
)

Vue.component(
  "invoice-overdue",
  require("./Components/Views/Transaction/InvoiceOverDue/Index").default
);
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------------------

// Inquiry
Vue.component(
  "app-inquiry",
  require("./Components/Views/Inquiry/Inquiry").default
);
Vue.component(
  "child-form",
  require("./Components/Views/Inquiry/ChildForm").default
);

// Event Registration - Diluar
Vue.component(
  "app-event-registration",
  require("./Components/Views/EventRegistration/EventRegistration").default
);
Vue.component(
  "event-child-form",
  require("./Components/Views/EventRegistration/ChildForm").default
);

// Transaction
// Lead
Vue.component(
  "lead",
  require("./Components/Views/Transaction/Lead/Index").default
);
// Lead Profile
Vue.component(
  "app-lead-profile",
  require("./Components/Views/Transaction/Lead/LeadProfile/LeadProfile").default
);
Vue.component(
  "lead-profile-form-wizard",
  require("./Components/Views/Transaction/Lead/LeadProfile/LeadProfileFormWizard")
    .default
);
Vue.component(
  "lead-profile-card",
  require("./Components/Views/Transaction/Lead/LeadProfile/LeadProfileCard")
    .default
);

// LeadProfile - Tabs
Vue.component(
  "lead-profile-tab-log",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Log/Log")
    .default
);
Vue.component(
  "lead-profile-tab-basic-info",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/BasicInfo/BasicInfo")
    .default
);
Vue.component(
  "lead-profile-tab-school",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/School/School")
    .default
);
Vue.component(
  "lead-profile-tab-language",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Language/Language")
    .default
);
Vue.component(
  "lead-profile-tab-personal",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Personal/Personal")
    .default
);
Vue.component(
  "lead-profile-tab-marketing",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Marketing/Marketing")
    .default
);
Vue.component(
  "lead-profile-tab-placement",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/Placement")
    .default
);
Vue.component(
  "lead-profile-tab-schedule",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Schedule/Schedule")
    .default
);
Vue.component(
  "lead-profile-tab-finance",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Finance/Finance")
    .default
);
Vue.component(
  "lead-profile-tab-class",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Class/Class")
    .default
);

Vue.component(
  "lead-profile-tab-log-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Log/LogTable")
    .default
);
Vue.component(
  "lead-profile-tab-school-school-history-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/School/SchoolHistoryTable")
    .default
);
Vue.component(
  "lead-profile-tab-personal-sibling-information-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Personal/PersonalSiblingInformationTable")
    .default
);
Vue.component(
  "lead-profile-tab-marketing-hdyk-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Marketing/MarketingHdykTable")
    .default
);
// Vue.component('lead-profile-tab-placement-placement-test-table', require('./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/PlacementF/PlacementTestTable').default)
// Vue.component('lead-profile-tab-placement-class-trial-behavior-table', require('./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/PlacementF/ClassTrialBehaviorTable').default)
// Vue.component('lead-profile-tab-placement-class-trial-skills-table', require('./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/PlacementF/ClassTrialSkillsTable').default)
Vue.component(
  "lead-profile-tab-placement-placement-booking",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/PlacementBooking")
    .default
);
Vue.component(
  "lead-profile-tab-placement-placement-booking-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/PlacementBookingTable")
    .default
);
Vue.component(
  "lead-profile-tab-placement-placement-history-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/PlacementHistoryTable")
    .default
);
Vue.component(
  "lead-profile-tab-placement-class-trial",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/ClassTrial")
    .default
);
Vue.component(
  "lead-profile-tab-placement-class-trial-behavior-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/ClassTrialBehaviorTable")
    .default
);
Vue.component(
  "lead-profile-tab-placement-class-trial-skills-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/ClassTrialSkillsTable")
    .default
);
Vue.component(
  "lead-profile-tab-placement-placement-test",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/PlacementTest")
    .default
);
Vue.component(
  "lead-profile-tab-placement-placement-test-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/PlacementTestTable")
    .default
);
Vue.component(
  "lead-profile-tab-placement-direct-placement",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/DirectPlacement")
    .default
);
Vue.component(
  "lead-profile-tab-placement-direct-placement-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/DirectPlacementTable")
    .default
);
// Vue.component('lead-profile-tab-schedule-preferred-schedule-table', require('./Components/Views/Transaction/Lead/LeadProfile/Tabs/Schedule/SchedulePreferredScheduleTable').default)
// Vue.component('lead-profile-tab-schedule-assign-schedule-table', require('./Components/Views/Transaction/Lead/LeadProfile/Tabs/Schedule/ScheduleAssignScheduleTable').default)
// Vue.component('lead-profile-tab-schedule-recommendations-table', require('./Components/Views/Transaction/Lead/LeadProfile/Tabs/Schedule/ScheduleRecommendationsTable').default)
// Vue.component('lead-profile-tab-schedule-schedules-table', require('./Components/Views/Transaction/Lead/LeadProfile/Tabs/Schedule/ScheduleSchedulesTable').default)
Vue.component(
  "lead-profile-tab-schedule-assign-schedule-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Schedule/AssignScheduleTable")
    .default
);
Vue.component(
  "lead-profile-tab-schedule-schedule-recommendation-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Schedule/ScheduleRecommendationTable")
    .default
);
Vue.component(
  "lead-profile-tab-finance-invoice-history",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Finance/InvoiceHistory")
    .default
);
Vue.component(
  "lead-profile-tab-finance-invoice-history-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Finance/InvoiceHistoryTable")
    .default
);
Vue.component(
  "lead-profile-tab-finance-invoice-request",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Finance/InvoiceRequest")
    .default
);
Vue.component(
  "lead-profile-tab-finance-invoice-process",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Finance/pdf/InvoiceProcess")
    .default
);
Vue.component(
  "lead-profile-tab-finance-study-information-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Finance/StudyInformationTable")
    .default
);
Vue.component(
  "lead-profile-tab-finance-fees-notice-details-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Finance/FeesNoticeDetailsTable")
    .default
);
Vue.component(
  "lead-profile-tab-finance-fees-notice-details-charges-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Finance/FeesNoticeDetailsChargesTable")
    .default
);
Vue.component(
  "lead-profile-tab-finance-fees-notice-details-deductions-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Finance/FeesNoticeDetailsDeductionsTable")
    .default
);
Vue.component(
  "lead-profile-tab-class-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Class/ClassTable")
    .default
);
Vue.component(
  "course-master",
  require("./Components/Views/Transaction/Course/Index").default
);

Vue.component(
  "continue-list",
  require("./Components/Views/Transaction/ContinueList/Index").default
);
Vue.component(
  "invoice-next",
  require("./Components/Views/Transaction/InvoiceNext/Index").default
);
// Vue.component(
//   "school-school-history-table",
//   require("./Components/Views/Transaction/ContinueList/Tabs/ConformSchool/SchoolHistoryTable").default
// );

Vue.component(
  "student-list-with-course",
  require("./Components/Views/Transaction/ContinueList/StudentListWithCourse")
    .default
);

Vue.component(
  "new-course-master",
  require("./Components/Views/Transaction/NewCourse/Index").default
);

Vue.component(
  "list-packages",
  require("./Components/Views/Master/ListPackages/Index").default
);
Vue.component(
  "course-group",
  require("./Components/Views/Transaction/CourseGroup/Index").default
);
Vue.component(
  "course-schedule",
  require("./Components/Views/Transaction/CourseSchedule/Index").default
);
Vue.component(
  "task-view-after-login",
  require("./Components/Views/Transaction/Task/Index").default
)

// Student Profile
Vue.component(
  "app-student-profile",
  require("./Components/Views/Transaction/Student/StudentProfile/StudentProfile").default
);
Vue.component(
  "student-profile-form-wizard",
  require("./Components/Views/Transaction/Student/StudentProfile/StudentProfileFormWizard")
    .default
);
Vue.component(
  "student-profile-card",
  require("./Components/Views/Transaction/Student/StudentProfile/StudentProfileCard")
    .default
);

// StudentProfile - Tabs
Vue.component(
  "student-profile-tab-log",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Log/Log")
    .default
);
Vue.component(
  "student-profile-tab-basic-info",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/BasicInfo/BasicInfo")
    .default
);
Vue.component(
  "student-profile-tab-school",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/School/School")
    .default
);
Vue.component(
  "student-profile-tab-language",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Language/Language")
    .default
);
Vue.component(
  "student-profile-tab-personal",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Personal/Personal")
    .default
);
Vue.component(
  "student-profile-tab-marketing",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Marketing/Marketing")
    .default
);
Vue.component(
  "student-profile-tab-placement",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/Placement")
    .default
);
Vue.component(
  "student-profile-tab-schedule",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Schedule/Schedule")
    .default
);
Vue.component(
  "student-profile-tab-finance",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Finance/Finance")
    .default
);
Vue.component(
  "student-profile-tab-class",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Class/Class")
    .default
);
Vue.component(
  "student-profile-tab-packages",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Packages/Packages")
    .default
);

Vue.component(
  "student-profile-tab-log-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Log/LogTable")
    .default
);
Vue.component(
  "student-profile-tab-school-school-history-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/School/SchoolHistoryTable")
    .default
);
Vue.component(
  "student-profile-tab-personal-sibling-information-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Personal/PersonalSiblingInformationTable")
    .default
);
Vue.component(
  "student-profile-tab-marketing-hdyk-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Marketing/MarketingHdykTable")
    .default
);
// Vue.component('student-profile-tab-placement-placement-test-table', require('./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/PlacementF/PlacementTestTable').default)
// Vue.component('student-profile-tab-placement-class-trial-behavior-table', require('./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/PlacementF/ClassTrialBehaviorTable').default)
// Vue.component('student-profile-tab-placement-class-trial-skills-table', require('./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/PlacementF/ClassTrialSkillsTable').default)
Vue.component(
  "student-profile-tab-placement-placement-booking",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/PlacementBooking")
    .default
);
Vue.component(
  "student-profile-tab-placement-placement-booking-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/PlacementBookingTable")
    .default
);
Vue.component(
  "student-profile-tab-placement-placement-history-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/PlacementHistoryTable")
    .default
);
Vue.component(
  "student-profile-tab-placement-class-trial",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/ClassTrial")
    .default
);
Vue.component(
  "student-profile-tab-placement-class-trial-behavior-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/ClassTrialBehaviorTable")
    .default
);
Vue.component(
  "student-profile-tab-placement-class-trial-skills-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/ClassTrialSkillsTable")
    .default
);
Vue.component(
  "student-profile-tab-placement-placement-test",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/PlacementTest")
    .default
);
Vue.component(
  "student-profile-tab-placement-placement-test-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/PlacementTestTable")
    .default
);
Vue.component(
  "student-profile-tab-placement-direct-placement",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/DirectPlacement")
    .default
);
Vue.component(
  "student-profile-tab-placement-direct-placement-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Placement/DirectPlacementTable")
    .default
);
// Vue.component('student-profile-tab-schedule-preferred-schedule-table', require('./Components/Views/Transaction/Student/StudentProfile/Tabs/Schedule/SchedulePreferredScheduleTable').default)
// Vue.component('student-profile-tab-schedule-assign-schedule-table', require('./Components/Views/Transaction/Student/StudentProfile/Tabs/Schedule/ScheduleAssignScheduleTable').default)
// Vue.component('student-profile-tab-schedule-recommendations-table', require('./Components/Views/Transaction/Student/StudentProfile/Tabs/Schedule/ScheduleRecommendationsTable').default)
// Vue.component('student-profile-tab-schedule-schedules-table', require('./Components/Views/Transaction/Student/StudentProfile/Tabs/Schedule/ScheduleSchedulesTable').default)
Vue.component(
  "student-profile-tab-schedule-assign-schedule-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Schedule/AssignScheduleTable")
    .default
);
Vue.component(
  "student-profile-tab-schedule-schedule-recommendation-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Schedule/ScheduleRecommendationTable")
    .default
);
Vue.component(
  "student-profile-tab-finance-invoice-history",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Finance/InvoiceHistory")
    .default
);
Vue.component(
  "student-profile-tab-finance-invoice-history-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Finance/InvoiceHistoryTable")
    .default
);
Vue.component(
  "student-profile-tab-finance-invoice-request",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Finance/InvoiceRequest")
    .default
);
Vue.component(
  "student-profile-tab-finance-invoice-process",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Finance/pdf/InvoiceProcess")
    .default
);
Vue.component(
  "profile-student-tab-invoice-invoice-process",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Invoice/pdf/InvoiceProcess")
    .default
);

Vue.component(
  "student-profile-tab-invoice-history",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Invoice/InvoiceHistory")
    .default
);
Vue.component(
  "student-profile-tab-invoice-history-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Invoice/InvoiceHistoryTable")
    .default
);
Vue.component(
  "student-lead-tab-invoice-history-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Invoice/InvoiceHistoryTable")
    .default
);
Vue.component(
  "student-profile-tab-invoice-invoice-request",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Invoice/InvoiceRequest")
    .default
);

Vue.component(
  "invoice-approval-request",
  require("./Components/Views/Transaction/InvoiceApproval/InvoiceRequest")
    .default
);

Vue.component(
  "lead-profile-tab-invoice-invoice-request",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Invoice/InvoiceRequest")
    .default
);
Vue.component(
  "lead-profile-tab-palcement-result",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/PlacementResult")
    .default
);

Vue.component(
  "lead-profile-tab-placement-result-test-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/PlacementResultTestTable")
    .default
);
Vue.component(
  "lead-profile-tab-placement-recommend-class-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/Placement/PlacementRecommendTable")
    .default
);

Vue.component(
  "student-profile-tab-finance-study-information-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Finance/StudyInformationTable")
    .default
);
Vue.component(
  "student-profile-tab-invoice-study-information-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Invoice/StudyInformationTable")
    .default
);
Vue.component(
  "invoice-approval-recommend-class-table",
  require("./Components/Views/Transaction/InvoiceApproval/RecommendClassTable")
    .default
);
Vue.component(
  "invoice-approval-confirmation-class-table",
  require("./Components/Views/Transaction/InvoiceApproval/ConfirmationClassTable")
    .default
);
Vue.component(
  "student-profile-tab-finance-fees-notice-details-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Finance/FeesNoticeDetailsTable")
    .default
);
Vue.component(
  "student-profile-tab-invoice-fees-notice-details-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Invoice/FeesNoticeDetailsTable")
    .default
);
Vue.component(
  "student-profile-tab-finance-fees-notice-details-charges-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Finance/FeesNoticeDetailsChargesTable")
    .default
);
Vue.component(
  "student-profile-tab-invoice-fees-notice-details-charges-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Invoice/FeesNoticeDetailsChargesTable")
    .default
);
Vue.component(
  "student-profile-tab-finance-fees-notice-details-deductions-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Finance/FeesNoticeDetailsDeductionsTable")
    .default
);
Vue.component(
  "student-profile-tab-invoice-fees-notice-details-deductions-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Invoice/FeesNoticeDetailsDeductionsTable")
    .default
);
Vue.component(
  "student-profile-tab-class-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Class/ClassTable")
    .default
);
Vue.component(
  "student-profile-tab-packages",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Packages/PackagesTable")
    .default
);
Vue.component(
  "student-profile-tab-va-number-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/VaNumber/VaNumberTable")
    .default
);
Vue.component(
  "lead-profile-tab-va-number-table",
  require("./Components/Views/Transaction/Lead/LeadProfile/Tabs/VaNumber/VaNumberTable")
    .default
);
Vue.component(
  "student-profile-tab-class-class-information",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Class/ClassInformation")
    .default
);
Vue.component(
  "student-profile-tab-class-study-details-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Class/StudyDetailsTable")
    .default
);
Vue.component(
  "student-profile-tab-class-student-attendance-table",
  require("./Components/Views/Transaction/Student/StudentProfile/Tabs/Class/StudentAttendanceTable")
    .default
);

// Parents Profile
Vue.component(
  "app-lead-parent-profile",
  require("./Components/Views/Transaction/Parent/ParentProfile/ParentProfile")
    .default
);
Vue.component(
  "app-lead-parent-profile-card",
  require("./Components/Views/Transaction/Parent/ParentProfile/ParentProfileCard")
    .default
);

// Parents Profile - Tabs
Vue.component(
  "parent-profile-tab-personal-info",
  require("./Components/Views/Transaction/Parent/ParentProfile/PersonalInformation")
    .default
);
Vue.component(
  "parent-profile-tab-children-info",
  require("./Components/Views/Transaction/Parent/ParentProfile/ChildrenInfo")
    .default
);
Vue.component(
  "parent-profile-tab-password-change",
  require("./Components/Views/Transaction/Parent/ParentProfile/PasswordChange")
    .default
);
Vue.component(
  "parent-profile-tab-social-links",
  require("./Components/Views/Transaction/Parent/ParentProfile/SocialLinks")
    .default
);

Vue.component(
  "parent-profile-tab-children-info-table",
  require("./Components/Views/Transaction/Parent/ParentProfile/ChildrenInfoTable")
    .default
);
Vue.component(
  "parent-profile-tab-finance-info-table",
  require("./Components/Views/Transaction/Parent/ParentProfile/FinanceTable")
    .default
);

// Lead List
Vue.component(
  "app-lead-list",
  require("./Components/Views/Transaction/Lead/LeadList/LeadList").default
);
Vue.component(
  "lead-list-table",
  require("./Components/Views/Transaction/Lead/LeadList/LeadListTable").default
);

// Student List
Vue.component(
  "app-student-list",
  require("./Components/Views/Transaction/Student/StudentList/StudentList").default
);
Vue.component(
  "student-list-table",
  require("./Components/Views/Transaction/Student/StudentList/StudentListTable").default
);

// Registration Event
Vue.component(
  "app-list-reqistration-event",
  require("./Components/Views/Transaction/Event/registration/index").default
);
Vue.component(
  "event-registration-find-list-table",
  require("./Components/Views/Transaction/Event/registration/RegistrantListTable").default
);

// Parent List
Vue.component(
  "app-parent-list",
  require("./Components/Views/Transaction/Parent/ParentList/ParentList").default
);
Vue.component(
  "parent-list-table",
  require("./Components/Views/Transaction/Parent/ParentList/ParentListTable").default
);

// Parent Interview
Vue.component(
  "app-parent-interview",
  require("./Components/Views/Transaction/ParentInterview/ParentInterview")
    .default
);
Vue.component(
  "parent-interview-form-wizard",
  require("./Components/Views/Transaction/ParentInterview/ParentInterviewFormWizard")
    .default
);
// Parent Interview - Tabs
Vue.component(
  "parent-interview-tab-basic-info",
  require("./Components/Views/Transaction/ParentInterview/Tabs/BasicInfo/BasicInfo")
    .default
);
Vue.component(
  "parent-interview-tab-school",
  require("./Components/Views/Transaction/ParentInterview/Tabs/School/School")
    .default
);
Vue.component(
  "parent-interview-tab-language",
  require("./Components/Views/Transaction/ParentInterview/Tabs/Language/Language")
    .default
);
Vue.component(
  "parent-interview-tab-consent",
  require("./Components/Views/Transaction/ParentInterview/Tabs/Consent/Consent")
    .default
);
Vue.component(
  "parent-interview-tab-booking",
  require("./Components/Views/Transaction/ParentInterview/Tabs/Booking/Booking")
    .default
);
Vue.component(
  "parent-interview-tab-booking-table",
  require("./Components/Views/Transaction/ParentInterview/Tabs/Booking/BookingTable")
    .default
);

Vue.component(
  "parent-interview-tab-school-school-history-table",
  require("./Components/Views/Transaction/ParentInterview/Tabs/School/SchoolHistoryTable")
    .default
);


// Academic
Vue.component(
  "academic-placement-list",
  require("./Components/Views/Transaction/Academic/Placement/List/PlacementList")
    .default
)
Vue.component(
  "academic-placement-list-table",
  require("./Components/Views/Transaction/Academic/Placement/List/PlacementListTable").default
);
Vue.component(
  "academic-group-find-list",
  require("./Components/Views/Transaction/Academic/Group/Find/List/GroupFindList")
    .default
)
Vue.component(
  "academic-group-find-list-table",
  require("./Components/Views/Transaction/Academic/Group/Find/List/GroupFindListTable").default
);
Vue.component(
  "academic-group-find-edit",
  require("./Components/Views/Transaction/Academic/Group/Find/Edit/GroupFindEdit").default
)
Vue.component(
  "academic-group-find-edit-study-details-table",
  require("./Components/Views/Transaction/Academic/Group/Find/Edit/StudyDetailsTable").default
);
Vue.component(
  "academic-group-find-edit-student-in-group-table",
  require("./Components/Views/Transaction/Academic/Group/Find/Edit/StudentInGroupTable").default
);
Vue.component(
  "academic-group-find-edit-class-timetable-table",
  require("./Components/Views/Transaction/Academic/Group/Find/Edit/ClassTimetableTable").default
)
Vue.component(
  "academic-group-new",
  require("./Components/Views/Transaction/Academic/Group/New/GroupNew").default
)
Vue.component(
  "academic-group-new-study-details-table",
  require("./Components/Views/Transaction/Academic/Group/New/StudyDetailsTable").default
)

// Teacher Pages - Schedule
Vue.component(
  "teacher-pages-schedule-form-wizard",
  require("./Components/Views/Transaction/TeacherPages/Schedule/ScheduleFormWizard.vue").default
);
Vue.component(
  "teacher-pages-schedule",
  require("./Components/Views/Transaction/TeacherPages/Schedule/Schedule.vue").default
)
Vue.component(
  "teacher-pages-schedule-table",
  require("./Components/Views/Transaction/TeacherPages/Schedule/ScheduleTable.vue").default
)
Vue.component(
  "teacher-pages-schedule-class-group-table",
  require("./Components/Views/Transaction/TeacherPages/Schedule/ScheduleClassGroupTable.vue").default
)
Vue.component(
  "teacher-pages-student-schedule-table",
  require("./Components/Views/Transaction/TeacherPages/Schedule/StudentScheduleTable.vue").default
)
// Teacher Pages - Attendance
Vue.component(
  "teacher-pages-attendance-form-wizard",
  require("./Components/Views/Transaction/TeacherPages/Attendance/AttendanceFormWizard.vue").default
)
Vue.component(
  "teacher-pages-attendance",
  require("./Components/Views/Transaction/TeacherPages/Attendance/Attendance.vue").default
)
Vue.component(
  "teacher-pages-attendance-table",
  require("./Components/Views/Transaction/TeacherPages/Attendance/AttendanceTable.vue").default
)
Vue.component(
  "teacher-pages-attendance-class-group-table",
  require("./Components/Views/Transaction/TeacherPages/Attendance/AttendanceClassGroupTable.vue").default
)
Vue.component(
  "teacher-pages-student-attendance-table",
  require("./Components/Views/Transaction/TeacherPages/Attendance/StudentAttendanceTable.vue").default
)

// Report

Vue.component(
  "inquiry-all-center",
  require("./Components/Views/Report/InquiryAllCenter/Index").default
);

Vue.component(
  "inquiry-by-center",
  require("./Components/Views/Report/InquiryByCenter/Index").default
);

Vue.component(
  "inquiry-by-marketing-channels",
  require("./Components/Views/Report/InquiryByMarketingChannels/Index").default
);

Vue.component(
  "report-lead-closing",
  require("./Components/Views/Report/LeadClosing/Index").default
);

